import { render, staticRenderFns } from "./UnitNew.vue?vue&type=template&id=48c4eb52"
import script from "./UnitNew.vue?vue&type=script&lang=js"
export * from "./UnitNew.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports